import { Component, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { FlattenPdfService } from '../../services/flatten-pdf.service';
import { TranslocoService } from '@jsverse/transloco';

@Component({
  selector: 'app-flatten-pdf',
  standalone: false,
  templateUrl: './flatten-pdf.component.html',
  styleUrls: ['./flatten-pdf.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FlattenPdfComponent {
  selectedFile: File | null = null;
  uploading = false;
  error: string | null = null;
  downloadUrl: string | null = null;

  constructor(
    private flattenPdfService: FlattenPdfService,
    private cdr: ChangeDetectorRef,
    private transloco: TranslocoService
  ) {}

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0];
    this.error = null;
    this.downloadUrl = null;
    if (file) {
      if (file.type !== 'application/pdf') {
        this.error = this.transloco.translate('flattenPdf.errorSelectPdf');
        this.selectedFile = null;
        this.cdr.markForCheck();
        return;
      }
      this.selectedFile = file;
    } else {
      this.selectedFile = null;
    }
    this.cdr.markForCheck();
  }

  onDrop(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.error = null;
    this.downloadUrl = null;
    const file = event.dataTransfer?.files?.[0];
    if (file?.type === 'application/pdf') {
      this.selectedFile = file;
    } else if (file) {
      this.error = this.transloco.translate('flattenPdf.errorDropPdf');
      this.selectedFile = null;
    }
    this.cdr.markForCheck();
  }

  onDragOver(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
  }

  onDragLeave(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
  }

  clearFile(): void {
    this.selectedFile = null;
    this.error = null;
    this.downloadUrl = null;
    const input = document.getElementById('flatten-pdf-file') as HTMLInputElement;
    if (input) {
      input.value = '';
    }
    this.cdr.markForCheck();
  }

  upload(): void {
    if (!this.selectedFile || this.uploading) {
      return;
    }
    this.uploading = true;
    this.error = null;
    this.downloadUrl = null;
    this.cdr.markForCheck();
    this.flattenPdfService.uploadAndFlatten(this.selectedFile).subscribe({
      next: ({ blob, filename }) => {
        this.uploading = false;
        const url = URL.createObjectURL(blob);
        this.downloadUrl = url;
        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        a.click();
        URL.revokeObjectURL(url);
        this.downloadUrl = null;
        this.clearFile();
        this.cdr.markForCheck();
      },
      error: (err) => {
        this.uploading = false;
        this.error = err?.error?.message ?? err?.message ?? this.transloco.translate('flattenPdf.errorUploadFailed');
        this.cdr.markForCheck();
      }
    });
  }
}
